import Departement from "./Departement_model";

export default class Pole extends Departement {
  static url = "poles/";
}
